<app-header [childValue]="selectedLang" (valueChanged)="onChildValueChanged($event)"></app-header>

<div class="body-container p-fluid p-formgrid justify-content-center mt-1"
    style="display: flex; align-items: center; flex-wrap: wrap;">

    <div class="field sm:col-12 md:col-12 lg:col-12 my-0 py-2 mx-0 px-2" style="display: flex; align-items: center;">
        <div class="static-button">
            <button pButton pRipple label="{{'BACK'| translate}}" icon="pi pi-arrow-left" class="back-button text-sm" (click)="goBack()"></button>
        </div>
        <div class="field sm:col-12 md:col-6 lg:col-10 px-2 photo-gallery-header"
            style="display: flex; align-items: center; justify-content: center;">
            <p>{{ 'SUCCESS_STORIES' | translate }}</p>
        </div>
    </div>
    <div class="img-conatiner">
        <p>Available soon!</p>
    </div>
</div>

<app-footer></app-footer>